import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './Savings.module.css';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const Savings = ({
    totalSaving,
    isLoading
}: {
    totalSaving: number;
    isLoading: boolean;
}) => {
    return (
        <SummaryRow isLoading={isLoading}>
            <div />
            <div
                className={classnames(styles.savesMe, {
                    [styles.loading]: isLoading
                })}
            >
                <FormattedMessage
                    id="_.draw_down.choose_amount.this_saves_me"
                    defaultMessage="this saves you"
                />
                <span data-testid="early-repayment-interest-savings">
                    <MoneyWithDecimals value={totalSaving} />
                </span>
            </div>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default Savings;
